// extracted by mini-css-extract-plugin
module.exports = {"title":"InAppHelpIcon_title__3vjPl","menu":"InAppHelpIcon_menu__2qjc9","menuItem":"InAppHelpIcon_menuItem__b2NPl","helpIcon":"InAppHelpIcon_helpIcon__2MKN7"};